import React from 'react';

import CourseContainer from '../../CourseContainer';
import Skeleton from '../../../Skeleton';

import { Container, CategoryTitle } from '../../CategoryContainer/styles';

const CategoryCourses: React.FC = () => (
  <Container aria-hidden="true">
    <CategoryTitle>
      <Skeleton className="category-title" />
    </CategoryTitle>
    <CourseContainer courses={[]} isLoading />
  </Container>
);

export default CategoryCourses;
